module.exports = __webpack_public_path__ + "img/baniere_adn83.12fe4ab0.png";